import axios from '@/common/utils/request'

// 修改密码
export function changePwd(params) {
  return axios({
    method: 'put',
    url: '/enroll/student/changePwd',
    data: params
  })
}

// 获取
export function getStudentInfo() {
  return axios({
    method: 'get',
    url: '/enroll/student/getStudentInfo'
  })
}


// 保存志愿
export function saveAdmit(params) {
  return axios({
    method: 'post',
    url: '/enroll/student/saveAdmit',
    data: params
  })
}

export function getVolInfo(action) {
  return axios({
    method: 'get',
    url: '/enroll/student/getVolInfo/' + action
  })
}
